import { map, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { SymbolClientAction } from '../symbolClient.action';

export const reloadSymbolClientCountersEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolClientAction.reload,
    SymbolClientAction.create.done,
    SymbolClientAction.update.done,
    SymbolClientAction.remove.done,
    SymbolClientAction.bulkRemove.done,
  ),
  withLatestFrom(action$.pipe(isTypeOfAndGetPayload(SymbolClientAction.loadCounters.started))),
  map(([, params]) => SymbolClientAction.loadCounters.started(params)),
);
